module.exports = __webpack_public_path__ + "static/img/bmsuccess.80ec1d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bmsuccess.png
// module id = xznY
// module chunks = 1